export default "__VITE_ASSET__BueQyFEU__"